import {
    checkFeatureFlagGate,
    featureFlags
} from "../../../utils/feature-flags";
import { isProduction } from "../../../utils/urls";
export {
    isProduction,
    getIdentityBaseUrl,
    getWacIntegrationUrl
} from "../../../utils/urls";

const RECAPTCHA_KEY = "6LeTa5ocAAAAAJefQaFL-1ENlPNY3Wq2j-GhcZ6n";
const RECAPTCHA_KEY_TEST = "6Lf0JekdAAAAAAWT2kBc89gFVKhxkwTPxa-e9tvx";
const IDENTITY_RECAPTCHA_KEY = "6Le9VxMnAAAAALKRlj8jmKwUYmFTZWcF0y4o9QeD";
const IDENTITY_RECAPTCHA_KEY_TEST = "6LcIg3QnAAAAAPmTkAv_ZanJY5dRDUJo-i5hr_aN";

export const getReCaptchaKey = () => {
    const recaptchaFlag = checkFeatureFlagGate(featureFlags.wacRecaptchaFlag);
    if (recaptchaFlag) {
        return isProduction()
            ? IDENTITY_RECAPTCHA_KEY
            : IDENTITY_RECAPTCHA_KEY_TEST;
    } else {
        return isProduction() ? RECAPTCHA_KEY : RECAPTCHA_KEY_TEST;
    }
};
